import { render, staticRenderFns } from "./search-title.vue?vue&type=template&id=78c1de23&scoped=true"
import script from "./search-title.vue?vue&type=script&lang=js"
export * from "./search-title.vue?vue&type=script&lang=js"
import style0 from "./search-title.vue?vue&type=style&index=0&id=78c1de23&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c1de23",
  null
  
)

export default component.exports